/**
 * Case chat WebSocket lifecycle helpers (transport is always WebSocket).
 */

import { caseChatWebSocketManager } from "../services/caseChatWebSocket";

/** Close the case chat socket when leaving a case or unmounting chat UI. */
export function releaseCaseChatWebSocket(caseId: number): void {
  if (!Number.isFinite(caseId) || caseId <= 0) return;
  caseChatWebSocketManager.closeCase(Math.trunc(caseId));
}

/** Close sockets for distinct case IDs (e.g. global drawer hidden). */
export function releaseChatWebSocketsForCases(caseIds: Iterable<number>): void {
  const seen = new Set<number>();
  for (const raw of caseIds) {
    const id = typeof raw === "number" ? raw : Number(raw);
    if (!Number.isFinite(id) || id <= 0) continue;
    const cid = Math.trunc(id);
    if (seen.has(cid)) continue;
    seen.add(cid);
    caseChatWebSocketManager.closeCase(cid);
  }
}
